"use client";

import { useState, useEffect } from "react";
import Header from "@/components/Header";
import HeroSection from "@/components/HeroSection";
import PortalSections from "@/components/PortalSections";
import ChatWidget from "@/components/ChatWidget";
import PDFViewer from "@/components/PDFViewer";
import StatsBar from "@/components/StatsBar";
import Footer from "@/components/Footer";
import ToolLibrary from "@/components/ToolLibrary";
import GpuSpeedometer from "@/components/GpuSpeedometer";

export default function Home() {
  const [activeView, setActiveView] = useState<"portal" | "pdf" | "chat" | "tools">("portal");
  const [selectedDocId, setSelectedDocId] = useState<string | undefined>(undefined);
  const [selectedDocTitle, setSelectedDocTitle] = useState<string | undefined>(undefined);
  const [experimentTrigger, setExperimentTrigger] = useState(0);
  const [pdfFocusDocId, setPdfFocusDocId] = useState<string | undefined>(undefined);

  // Support ?view=tools (or other views) in the URL so external links can deep-link
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const view = params.get("view") as "portal" | "pdf" | "chat" | "tools" | null;
    if (view && ["portal", "pdf", "chat", "tools"].includes(view)) {
      setActiveView(view);
    }
  }, []);

  return (
    <main className="min-h-screen flex flex-col">
      <Header activeView={activeView} setActiveView={setActiveView} />
      <StatsBar />

      {activeView === "portal" && (
        <>
          <HeroSection
            setActiveView={setActiveView}
            onOpenExperiment={() => { setActiveView("portal"); setExperimentTrigger((t) => t + 1); }}
          />
          <PortalSections
            experimentTrigger={experimentTrigger}
            onNavigateToPdf={(docId) => { setPdfFocusDocId(docId); setActiveView("pdf"); }}
          />
        </>
      )}

      {activeView === "pdf" && <PDFViewer focusDocId={pdfFocusDocId} onDocSelect={(id, title) => { setSelectedDocId(id); setSelectedDocTitle(title); }} />}

      {activeView === "chat" && (
        <div className="flex-1 flex">
          <ChatWidget fullscreen selectedDocId={selectedDocId} selectedDocTitle={selectedDocTitle} />
        </div>
      )}

      {activeView === "tools" && <ToolLibrary />}

      <Footer />
      {activeView !== "chat" && <ChatWidget selectedDocId={selectedDocId} selectedDocTitle={selectedDocTitle} />}
      <GpuSpeedometer />
    </main>
  );
}
